/* eslint-disable no-unused-vars */
export enum User {
    Parent,
    Admin,
    Teacher
}
/**
 * Phone Number Regex validates the following:
const validNumbers = [
    // International formats
    '+12125556789',     // US
    '+447123456789',    // UK
    '+2348012345678',   // Nigeria
    '+8613912345678',   // China
    '+919876543210',    // India
    '00447123456789',   // UK (using 00)
    
    // Local formats
    '02012345678',      // UK local
    '08012345678',      // Nigerian local
    '0123456789012'     // Generic local
];

const invalidNumbers = [
    '+0123456789',      // Invalid (country code can't start with 0)
    '12345',            // Too short
    '+123456789012345678', // Too long
    'abcdefghijk',      // Non-numeric
    '+',                // Just a plus
    '00'               // Just international prefix
];
 */
const PHONE_NUMBER_REGEX = /^(?:(?:\+|00)[1-9]\d{1,14}|0\d{9,14})$/

const TOKEN_KEY = 'children-church-auth-token'
const REFRESH_TOKEN_KEY = 'children-church-refresh-token'

export { PHONE_NUMBER_REGEX, TOKEN_KEY, REFRESH_TOKEN_KEY }
